import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ResetNav {}

export const resetNav = createAction<ActionType, ResetNav>(
    ActionType.COACHING_DETAIL__TD__RESET_NAV,
);
